module.exports = __webpack_public_path__ + "img/icon7.93e8bf07.svg";